var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCursor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.98512 3.78981L7.532 15.9148C7.57719 16.0341 7.65781 16.1368 7.76304 16.2089C7.86827 16.2811 7.99307 16.3193 8.12065 16.3184C8.24824 16.3176 8.37251 16.2777 8.47677 16.2042C8.58103 16.1306 8.66028 16.0269 8.70387 15.907L10.5242 10.8992C10.5558 10.8133 10.6058 10.7353 10.6705 10.6705C10.7353 10.6058 10.8133 10.5558 10.8992 10.5242L15.907 8.70387C16.0269 8.66028 16.1306 8.58103 16.2042 8.47677C16.2777 8.37251 16.3176 8.24824 16.3184 8.12065C16.3193 7.99307 16.2811 7.86827 16.2089 7.76304C16.1368 7.65781 16.0341 7.57719 15.9148 7.532L3.78981 2.98512C3.67744 2.94298 3.55532 2.93407 3.43803 2.95947C3.32073 2.98487 3.21323 3.04351 3.12837 3.12837C3.04351 3.21323 2.98487 3.32073 2.95947 3.43803C2.93407 3.55532 2.94298 3.67744 2.98512 3.78981V3.78981Z",
    stroke: "#1A181E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6719 10.6719L16.25 16.25",
    stroke: "#1A181E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursor);
export default __webpack_public_path__ + "static/media/cursor.a6055e220b45ef823372754c3cfa5b56.svg";
export { ForwardRef as ReactComponent };